/** Default post-auth landing route: Prompts for every persona. */
export function getDefaultLandingPath(): '/dashboard' {
  return '/dashboard';
}
